import axios, { AxiosRequestConfig } from 'axios'
import { getEnv } from '@unni/platform'

import { extractLocaleFromUrlPath } from '@/utils/language'

export const SERVER_SERVICE = {
  solar: 'solar',
} as const

export const buildApiEndpoint = (
  config: AxiosRequestConfig,
  serviceKey: keyof typeof SERVER_SERVICE,
): AxiosRequestConfig => {
  if (typeof window === 'undefined') {
    return config
  }

  const baseUrl = '/api'
  const servicePath = SERVER_SERVICE[serviceKey]
  const endpoint = config.url || ''

  return {
    ...config,
    url: `${baseUrl}/${servicePath}${endpoint}`,
  }
}

export enum CustomHeaders {
  X_ACCEPT_LANGUAGE = 'x-accept-language',
}
export const createSolarApiClient = (config?: AxiosRequestConfig) => {
  const isServer = typeof window === 'undefined'
  if (isServer) {
    const instance = axios.create({
      baseURL: getEnv('SOLAR_API_HOST'),
      ...config,
    })

    return instance
  }

  const instance = axios.create({
    ...config,
  })

  instance.interceptors.request.use((config) => {
    const pageUrl = new URL(window.location.href)
    const locale = extractLocaleFromUrlPath(pageUrl.pathname)
    const headers = {
      'Content-Type': 'application/json',
      ...config.headers,
      [CustomHeaders.X_ACCEPT_LANGUAGE]: locale,
    }
    config.headers = headers
    return config
  })
  return instance
}
